import { useTranslation } from 'react-i18next';
import { Tooltip } from '@/components/Tooltip';

/**
 * RU/EN language toggle. Used in the cispracs rail in place of the theme
 * toggle — cispracs has no light theme, so that control would be a no-op,
 * and a quick language flip is more useful there.
 *
 * Shows the active language code; clicking flips to the other one.
 * `i18n.changeLanguage` persists to localStorage (`bunker.lang`) and
 * re-renders everything subscribed via `useTranslation`.
 */
export function LanguageToggle({ className = '' }: { className?: string }) {
  const { t, i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage ?? 'ru').startsWith('en') ? 'en' : 'ru';
  const next = lang === 'ru' ? 'en' : 'ru';
  const title = t('ui.languageToggle');
  return (
    <Tooltip label={title}>
    <button
      type="button"
      onClick={() => void i18n.changeLanguage(next)}
      aria-label={title}
      className={
        'group shrink-0 rounded-lg px-1.5 py-1 text-[11px] font-semibold uppercase tracking-wide text-ink-dim transition-colors hover:bg-default/60 hover:text-ink ' +
        className
      }
    >
      {lang}
    </button>
    </Tooltip>
  );
}
